import { Component, ComponentInterface, h } from '@stencil/core';
import state from '../../../store';

import URLS from '../app-root/urls';

@Component({
  tag: 'app-footer',
  styleUrl: 'style.scss',
  shadow: false
})
export class AppFooter implements ComponentInterface {
  /**
   * Enable GDPR
   */
  showGdpr() {
    state.gdprEnabledFooter  = true;
  }

  render() {
    return (
      <div class='footer'>
        <div class='page-container-wrapper'>
          <div class='page-container'>
            <div class="col-xxs-12">
              <div class="footer-links">
                <ul class="toggle-footer-menu">
                  <li>Produkt</li>
                  <li>
                    <stencil-route-link url={URLS.AppProduct}>
                      Czym jest Zento
                    </stencil-route-link>
                  </li>
                  <li>
                    <stencil-route-link url={URLS.AppProductDesignPWA}>
                      Design &amp; PWA
                    </stencil-route-link>
                  </li>
                  <li>
                    <stencil-route-link url={URLS.AppProductMagento2core}>
                      Magento Core
                    </stencil-route-link>
                  </li>
                  <li>
                    <stencil-route-link url={URLS.AppProductProcess}>
                      Proces
                    </stencil-route-link>
                  </li>
                  <li>
                    <stencil-route-link url={URLS.AppProductHosting}>
                      Hosting
                    </stencil-route-link>
                  </li>
                  <li>
                    <stencil-route-link url={URLS.AppProductGdprDataGovernanace}>
                      RODO &amp; Prywatność
                    </stencil-route-link>
                  </li>
                  <li>
                    <a href='https://www.zentoshop.com/wiki' rel='noopener' title='Zento Wiki'>
                      Baza wiedzy o Zento
                    </a>
                  </li>
                  <li>
                    <span
                      onClick={ this.showGdpr }
                      class='item-link'
                    >
                      Twoje zgody
                    </span>
                  </li>
                </ul>
                <ul>
                  <li>Przejście do Zento</li>
                  <li>
                    <stencil-route-link url={URLS.AppProcessForSwitching}>
                      Procedura
                    </stencil-route-link>
                  </li>
                  <li>
                    <stencil-route-link url={URLS.AppReasonsForSwitching}>
                      Powody do zmiany
                    </stencil-route-link>
                  </li>
                  {/* <li style={ { display: 'none' } }>
                    <stencil-route-link url={URLS.AppLps}>Reasons to buy</stencil-route-link>
                  </li> */}
                </ul>
                <ul>
                  <li>Partnerstwo</li>
                  <li>
                    <stencil-route-link url={URLS.AppFindPartner}>
                      Znajdź partnera
                    </stencil-route-link>
                  </li>
                  <li>
                    <stencil-route-link url={URLS.AppBecomePartner}>
                      Zostań partnerem
                    </stencil-route-link>
                  </li>
                  <li>
                    <stencil-route-link url={URLS.AppAffiliate}>
                      Afiliacja
                    </stencil-route-link>
                  </li>
                </ul>
                <ul>
                  <li>Firma</li>
                  <li>
                    <stencil-route-link url={URLS.AppAbout}>
                      Nasza historia
                    </stencil-route-link>
                  </li>
                  <li>
                    <stencil-route-link url={URLS.AppLeadershipTeam}>
                      Kierownictwo i zespół
                    </stencil-route-link>
                  </li>
                  <li>
                    <stencil-route-link url={URLS.AppCareers}>
                      Kariera
                    </stencil-route-link>
                  </li>
                  <li>
                    <stencil-route-link url={URLS.AppDataProtectionAndPrivacy}>
                      Ochrona danych
                    </stencil-route-link>
                  </li>
                    <stencil-route-link url={URLS.AppBlog}>
                      Artykuły
                    </stencil-route-link>
                  <li class='footer-logos'>
                    <div class='footer-logo-item'>
                        <span>Part of</span>
                        <p>
                            <a href='https://r22.pl/' rel='noopener' target='_blank'>
                              <picture>
                                <source
                                  srcSet='../../assets/media/R22-logo-small.webp'
                                  type='image/webp'
                                />

                                <img
                                  alt='SaaS'
                                  src='../../assets/media/R22-logo-small.png'
                                  loading='lazy'
                                  width='67'
                                  height='32'
                                />
                              </picture>
                            </a>
                        </p>
                    </div>
                    <div class='footer-logo-item'>
                      <p>
                        <picture>
                          <source
                            srcSet='../../assets/media/cf_logo.webp'
                            type='image/webp'
                          />

                          <img
                            alt='cf'
                            src='../../assets/media/cf_logo.png'
                            loading='lazy'
                            width='215'
                            height='32'
                          />
                        </picture>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class='branding'>
              <p class='copyright'>
                  Copyright © 2020  All rights reserved
                  <a href='https://www.zentoshop.com' rel='noopener' target='_blank' title='Zento'>
                    <strong>Zento</strong>
                  </a>
              </p>
              <ul class='list'>
                <li class='list__item facebook'>
                  <a href='https://www.facebook.com/my.zento.shop/' title='Facebook' rel='noopener' target='_blank'></a>
                </li>
                <li class='list__item twitter'>
                  <a href="https://twitter.com/ShopZento" title='Linkedin' rel='noopener' target='_blank'></a>
                </li>
                <li class='list__item linkedin'>
                  <a href="https://www.linkedin.com/company/zentoshop/" title='Linkedin' rel='noopener' target='_blank'></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
